import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { Popup, DropdownItemType, Text, Dropdown } from 'components'

import { User, useAppDispatch } from 'store'
import useBranch from 'hooks/use-branch'
import { getUserPermission } from 'services/user'
import { ROUTES } from '../../constants/constants'

interface IProps {
  visible: boolean
  onClose: () => void
}

const ChangeBranchModal: React.FC<IProps> = (props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { selectedBranch, userBranches } = useBranch()

  const branchOptions: DropdownItemType<string>[] = userBranches.map((item) => ({
    value: item.id,
    label: item?.branchName,
  }))

  const { onClose, visible } = props
  const [currSelectBranch, setCurrSelectBranch] = useState(selectedBranch)

  const handlePrimaryClick = () => {
    const selectedBranch = userBranches.find((item) => item.id === currSelectBranch?.id)
    dispatch(User.setSelectedBranch(selectedBranch))
    dispatch(getUserPermission())

    //TODO: temporary approach to force user to redirect to home after changing branch to refresh data
    navigate(ROUTES.HOME)
    handleClose()
  }

  const handleSelect = (branch: DropdownItemType<string>) => {
    const selectedBranch = userBranches.find((item) => item.id === branch.value)
    setCurrSelectBranch(selectedBranch)
  }

  const handleClose = () => {
    setCurrSelectBranch(selectedBranch)
    onClose()
  }

  return (
    <>
      {visible ? (
        <Popup
          minWidth={'650px'}
          minHeight={'350px'}
          width={'700px'}
          onClickPrimary={() => handlePrimaryClick()}
          onClickSecondary={handleClose}
          labelPrimary="confirm_btn"
          labelSecondary="cancel_btn"
        >
          <Container>
            <Text fontSize={36} fontWeight="normal" mb={12}>
              branch_other
            </Text>
            <Text mb={23}>branch_modal_info</Text>
            <Dropdown
              defaultValue={branchOptions.find((item) => item.value === selectedBranch?.id)}
              inline
              isDisabled={branchOptions.length === 1}
              isClearable={false}
              isSearchable={false}
              name="branch-select"
              onChange={handleSelect}
              options={branchOptions}
              width="auto"
              value={branchOptions.find((i) => i.value === currSelectBranch?.branchId)}
            />
          </Container>
        </Popup>
      ) : null}
    </>
  )
}

export default ChangeBranchModal

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding-top: 60px;
`
